import { Nullable } from '../types/types';

export const setStorageItem = (key: string, value: string) => {
  // Preventing iOS from crashing when trying to set null as value
  let storageItemValue = value;
  if (storageItemValue === null) {
    storageItemValue = '';
  }

  try {
    window.localStorage.setItem(key, storageItemValue);
  } catch (_e) {
    // ignore errors
  }
};

export const getStorageItem = <TType = string>(key: string): Nullable<TType> => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? (item as unknown as TType) : null;
  } catch (_e) {
    // ignore errors
    return null;
  }
};

export const removeStorageItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (_e) {
    // ignore errors
  }
};

export const clearStorage = () => {
  try {
    window.localStorage.clear();
  } catch (_e) {
    // ignore errors
  }
};
